import Line from "../../../../../src/entities/Line/Line";
import { rootEventBus, EnumRootEventBus } from "../../../../../src/managers/RootEventBus";
import { Coord } from "../../../../../src/types/Interface";
import { PURPLE_COLORS } from "../types/Config";


export default class LineManager {
  triangle = [new Line(), new Line(), new Line()];
  tangent = new Line({ color: PURPLE_COLORS[0] });
  private colors: number[];
  private ishownSecondSegment = true;
  private showPink = true;

  constructor(colors: number[]) {
    this.colors = colors;
    rootEventBus.on(EnumRootEventBus.startedCircleAnim, () => {
      this.clearAll();
      this.showPink = true;
    });
  }
  setQuasimodo(status: boolean){
    this.showPink =! status;
  }
  setAllVisible = (status: boolean) => [this.tangent, ...this.triangle].forEach(l => l.visible = status);
  setIsShowSecondSegment = (status: boolean) => this.ishownSecondSegment = status;
  clearAll() {
    this.triangle.forEach(l => {
      l.setLineColor(0x000000);
      l.clear()
    });
    this.tangent.clear();
  }
  draw(points: Coord[], tPoints: Coord[], sltdTPIndex: number) {
    const sI = sltdTPIndex;
    const prevI = sI != 0 ? sI - 1 : points.length - 1;

    this.triangle.forEach((line, lI) => {
      line.setLineColor(lI == sI ? this.showPink ? this.colors[1] : 0x000000 : lI == prevI && this.ishownSecondSegment ? this.colors[0] : 0x000000);
      line.draw(points[lI], points[points.length == lI + 1 ? 0 : lI + 1])
    });
    this.tangent.draw(tPoints[0], tPoints[1]);
  }
}


